<div class="success-dialog-container" [class.show]="show()">
  @if (message().type !== "loader") {
    <div class="success-dialog d-flex justify-center">
      @if (message().type === "message") {
        <p class="dialog-text">{{ message().text }}</p>
      }
      @if (message().type === "error") {
        <div class="dialog-text">
          <p class="dialog-text">Sorry, it didn't work.</p>
          <p class="error-message">{{ message().text }}</p>
          <button class="primary-button" (click)="closeDialog()">
            TRY AGAIN
          </button>
        </div>
      }
    </div>
  }
  @if (message().type === "loader") {
    <div class="loader" id="loader"></div>
  }
</div>
